export const ThemeConfiguration = {
    primaria: '#0ae082',
    secundaria: '#0054ff',
    dark: '#333333'
}